import { useUI } from "providers/UIProvider"
import Modal from "components/UI/organisms/Modal"
import TransactionsTable from "../../../templates/TransactionsTemplate/TransactionsTable"

const ClientTransactionsModal = () => {
  const { modals, toggleModal, T } = useUI()

  return (
    <Modal
      isOpen={modals.clientTransactionsModal.isOpened}
      onClose={() => toggleModal("clientTransactionsModal", false)}
      title={T("transactions.title")}
      styles={{
        headerPadding: "20px 15px 20px 23px",
        width: "93%",
        bodyPadding: "0px 0px 0px 0px",
      }}
    >
      <TransactionsTable />
    </Modal>
  )
}

export default ClientTransactionsModal
